import { render } from "./courseManagement.vue?vue&type=template&id=1a924e51&scoped=true"
import script from "./courseManagement.vue?vue&type=script&lang=js"
export * from "./courseManagement.vue?vue&type=script&lang=js"

import "./courseManagement.vue?vue&type=style&index=0&id=1a924e51&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a924e51"]])

export default __exports__